import React, { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { useLocation } from "react-router-dom";

interface TrackingInfo {
  trackingUrl: string;
}

async function loadTrackingInfo(): Promise<TrackingInfo> {
  let response: AxiosResponse = await axios.get("/grld-public/tracking/v1/url");
  return response.data;
}

export const IFrameTracking = (props: {
  trackingKey: string;
}) => {
  const { search } = useLocation();
  const [trackingInfo, setTrackingInfo] = useState<TrackingInfo>();
  const [queryString, setQueryString] = useState<string>();

  useEffect(() => {
    loadTrackingInfo()
      .then(function (trackingInfo: TrackingInfo) {
        setTrackingInfo(trackingInfo);
      })
      .catch(function (e) {
        // do nothing - tracking not available
      });
  }, []);

  useEffect(() => {
    const trackingParams = [
      "cid",
      "pid",
      "pdata",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];
    const queryObject = new URLSearchParams(search);
    let queryString = "";
    let urlWithoutEmailParam = window.location.origin + window.location.pathname + "?"

    queryObject.forEach(
        (value, key) => {
          (queryString += trackingParams.includes(key)
              ? "&" + key + "=" + value
              : "");

          (urlWithoutEmailParam += key.toLowerCase() !== "email"
              ? "&" + key + "=" + value
              : "");
        }
    );

    queryString += "&pageUrl=" + urlWithoutEmailParam;
    setQueryString(() => queryString);
  }, [search]);

  return (
    <>
      {trackingInfo !== undefined && (
        <iframe
          title="tracking"
          data-testid="iframetracking"
          src={trackingInfo.trackingUrl + "?" + props.trackingKey + queryString}
          style={{
            height: 0,
            width: 0,
            position: "absolute",
            zIndex: -1000,
            display: "none",
          }}
        ></iframe>
      )}
    </>
  );
};
